import { size, sum, uniq, zipWith } from 'lodash'

import regex from 'helpers/formatters/regex'

// CPF-teste conhecido: passa no cálculo do dígito verificador, mas nunca foi de fato emitido
const KNOWN_TEST_CPF = '12345678909'

const FIRST_CHECK_DIGIT_WEIGHTS = [10, 9, 8, 7, 6, 5, 4, 3, 2]
const SECOND_CHECK_DIGIT_WEIGHTS = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]

const isAllDigitsRepeated = (value) => size(uniq(value.split(''))) === 1

const calculateCheckDigit = (digits, weights) => {
  const weightedValues = zipWith(
    digits.split(''),
    weights,
    (digit, weight) => Number(digit) * weight,
  )

  const remainder = (sum(weightedValues) * 10) % 11
  return remainder >= 10 ? 0 : remainder
}

const isValid = (value) => {
  const sanitizedValue = regex.onlyNumbers(value)

  if (
    size(sanitizedValue) !== 11 ||
    isAllDigitsRepeated(sanitizedValue) ||
    sanitizedValue === KNOWN_TEST_CPF
  ) {
    return false
  }

  const baseDigits = sanitizedValue.slice(0, 9)
  const informedCheckDigits = sanitizedValue.slice(9)

  const firstCheckDigit = calculateCheckDigit(
    baseDigits,
    FIRST_CHECK_DIGIT_WEIGHTS,
  )
  const secondCheckDigit = calculateCheckDigit(
    baseDigits + firstCheckDigit,
    SECOND_CHECK_DIGIT_WEIGHTS,
  )

  return informedCheckDigits === `${firstCheckDigit}${secondCheckDigit}`
}

const cpf = { isValid }

export default cpf
